/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import ajaxCallStation from '../util/remote/ajaxCallStation';
import ajaxStation from '../util/remote/ajaxStation';
import SchoolContext from './SchoolContext';
import ajaxBank from '../util/remote/ajaxBank';
const StationContext = React.createContext();

export const StationConsumer = StationContext.Consumer;

export const StationProvider = (props)=> {

   
    const [stationNumber, setStationNumber] = useState(false);
    const [activeStationNumber, setActiveStationNumber] = useState(false);
    const [inactiveStationNumber, setInactiveStationNumber] = useState(false);
    const [offStationNumber, setOffStationNumber] = useState(false);
    const [schoolStationNumber, setSchoolStationNumber] = useState(false);

    const [schoolDashboardStations, setSchoolDashboardStations] = useState([]);
    const [schoolDashboardVendors, setSchoolDashboardVendors] = useState([]);


    const [stationList, setStationList] = useState([]);
    const [allStationList, setAllStationList] = useState([]);

    const [groupedStationList, setGroupedStationList] = useState([]);
    const [stationTimeRanges, setStationTimeRanges] = useState([]);
    const [stationActivity, setStationActivity] = useState([]);

    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loading4, setLoading4] = useState(false);
    const [query, setQuery] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    const [page, setPage] = useState(1);
    const { schoolDetails } = useContext(SchoolContext);
    const [loading5, setLoading5] = useState(false);

    const [globalStationSettings, setGlobalStationSettings] = useState(false);
    const [schoolStationSettings, setSchoolStationSettings] = useState(false);
    const [stationSettings, setStationSettings] = useState(false);

    const [meta, setMeta] = useState([]);
    const schoolID = schoolDetails.school_id;

    useEffect(()=>{
      getStationNumber();
      getActiveStationNumber();
      getInactiveStationNumber();
      getOffStationNumber();
      getStationActivity();
      getAllStations();
   }, [])

   useEffect(()=>{
    getSchoolStationNumber();
 }, [schoolID])
  
   const getSchoolStationNumber = async () => {
    setSchoolStationNumber(false)
    const server_response = await ajaxCallStation.callStation_count(schoolID);
    if (server_response.status === "OK") {
      //store results
      setSchoolStationNumber(server_response.details);
    } else {
      //communicate error
      setSchoolStationNumber("404");
    }
  };

  const getStationNumber = async () => {
    setStationNumber(false)
    const server_response = await ajaxCallStation.countAllStations();
    if (server_response.status === "OK") {
      //store results
      setStationNumber(server_response.details);
    } else {
      //communicate error
      setStationNumber("404");
    }
  };

  const getActiveStationNumber = async () => {
    setActiveStationNumber(false)
    const server_response = await ajaxCallStation.countActiveStations();
    if (server_response.status === "OK") {
      //store results
      setActiveStationNumber(server_response.details);
    } else {
      //communicate error
      setActiveStationNumber("404");
    }
  };

  const getInactiveStationNumber = async () => {
    setInactiveStationNumber(false)
    const server_response = await ajaxCallStation.countInactiveStations();
    if (server_response.status === "OK") {
      //store results
      setInactiveStationNumber(server_response.details);
    } else {
      //communicate error
      setInactiveStationNumber("404");
    }
  };

  const getOffStationNumber = async () => {
    setOffStationNumber(false)
    const server_response = await ajaxCallStation.countOffStations();
    if (server_response.status === "OK") {
      //store results
      setOffStationNumber(server_response.details);
    } else {
      //communicate error
      setOffStationNumber("404");
    }
  };

  const getStations = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxStation.listAllStations(currentPage);
    setLoading(false);
    if (server_response.status === "OK") {
      setMeta(server_response.details.meta.list_of_pages);
      const stations = server_response.details.list || [];
      setStationList(stations);
      stations.forEach(station => {
        getStationTimeRanges(station.station_id);
      });
    } else {
      setStationList([]);
    }
  };

  const getGroupedStations = async () => {
    setLoading3(true);
    const server_response = await ajaxStation.listGroupedStations();
    setLoading3(false);
    
    if (server_response.status === "OK") {
      const stationsGrouped = server_response.details || {};
      setGroupedStationList(stationsGrouped);
      Object.values(stationsGrouped).forEach(stationArray => {
        stationArray.forEach(station => {
          getStationTimeRanges(station.station_id);
        });
      });
      
    } else {
      setGroupedStationList({});
    }
  };

  const searchGroupedStations = async () => {
    setLoading4(true);
    const server_response = await ajaxStation.searchGroupedStations(searchQuery);
    setLoading4(false);
    
    if (server_response.status === "OK") {
      const stationsGrouped = server_response.details || {};
      setGroupedStationList(stationsGrouped);
      Object.values(stationsGrouped).forEach(stationArray => {
        stationArray.forEach(station => {
          getStationTimeRanges(station.station_id);
        });
      });
      
    } else {
      setGroupedStationList({});
    }
  };



  const getSchoolStations = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxStation.fetchStationList(schoolID,currentPage);
    setLoading(false);
    if (server_response.status === "OK") {
      setMeta(server_response.details.meta.list_of_pages);
      const stations = server_response.details.list || [];
      setStationList(stations);
      stations.forEach(station => {
        getStationTimeRanges(station.station_id); // Fetch time ranges for each station
      });
    } else {
      setStationList([]);
    }
  };

  const getStationTimeRanges = async (stationId) => {
    setLoading5(true);
    const server_response = await ajaxStation.fetchStationTimeRanges(stationId);
    setLoading5(false);
    if (server_response.status === "OK") {
      setStationTimeRanges(prevState => ({
        ...prevState,
        [stationId]: server_response.details || [],
      }));
    } else {
      setStationTimeRanges(prevState => ({
        ...prevState,
        [stationId]: [],
      }));
    }
  };

  const searchStations = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStation.searchAllStations(query,page);
    setLoading2(false);
    if (server_response.status === "OK") {
      setMeta(server_response.details.meta.list_of_pages);
      setStationList(server_response.details.list || []);
    } else {
      setStationList([]);
    }
  };

  const searchSchoolStations = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStation.searchStation(
      schoolID,
      query,
      page
    );
    setLoading2(false);
    if (server_response.status === "OK") {
      setMeta(server_response.details.meta.list_of_pages);
      setStationList(server_response.details.list || []);
    } else {
      setStationList([]);
    }
  };

  const getSchoolDashboardStations = async () => {
    const server_response = await ajaxStation.fetchFewStations(schoolID);
    if (server_response.status === "OK") {
      setSchoolDashboardStations(server_response.details);
    } else {
      setSchoolDashboardStations("404");
    }
  };

  const getSchoolDashboardVendors = async () => {
    const server_response = await ajaxBank.fetchSchoolDashboardVendors(schoolID);
    if (server_response.status === "OK") {
      setSchoolDashboardVendors(server_response.details);
    } else {
      setSchoolDashboardVendors("404");
    }
  };


  const getStationActivity = async () => {  
    const server_response = await ajaxStation.fetchStationActivity();
    if (server_response.status === "OK") {
      setStationActivity(server_response.details);
    } else {
      setStationActivity("404");
    }
  }

  const getGlobalStationSettings =async()=>{
  
    const server_response = await ajaxStation.fetchGlobalStationSettings();
    if(server_response.status==="OK"){
        //store results
        setGlobalStationSettings(server_response.details);
    }else{
        //communicate error
        setGlobalStationSettings("404");
    }
  }
  
  const getSchoolStationSettings =async()=>{

    const server_response = await ajaxStation.fetchSchoolStationSettings();
    if(server_response.status==="OK"){
        //store results
        setSchoolStationSettings(server_response.details);
    }else{
        //communicate error
        setSchoolStationSettings("404");
    }
  }
  
  const getStationSettings =async()=>{

    const server_response = await ajaxStation.fetchStationSettings();
    if(server_response.status==="OK"){
        //store results
        setStationSettings(server_response.details);
    }else{
        //communicate error
        setStationSettings("404");
    }
  }

  const getAllStations = async () => {
    const server_response = await ajaxStation.getAllStationList();
    if (server_response.status === "OK") {
      setAllStationList(server_response.details);
    } else {
      setAllStationList("404");
    }
  };
    
    return (
           <StationContext.Provider value={
               {
                    stationNumber,
                    schoolStationNumber,
                    activeStationNumber,
                    inactiveStationNumber,
                    offStationNumber,
                    stationList,
                    groupedStationList,
                    stationTimeRanges,
                    stationActivity,
                    query,
                    searchQuery,
                    stationSettings,
                    globalStationSettings,
                    schoolStationSettings,
                    allStationList,
                    page,
                    meta,
                    loading,
                    loading2,
                    loading3,
                    loading4,
                    loading5,
                    schoolID,
                    schoolDashboardStations,
                    schoolDashboardVendors,
                    setQuery,
                    setSearchQuery,
                    setPage,
                    setMeta,
                  getStationNumber,
                  getStations,
                  getGroupedStations,
                  getSchoolStations,
                  searchStations,
                  searchSchoolStations,
                  getSchoolDashboardStations,
                  getSchoolDashboardVendors,
                  getActiveStationNumber,
                  getInactiveStationNumber,
                  getOffStationNumber,
                  getStationActivity,
                  searchGroupedStations,
                  getGlobalStationSettings,
                  getSchoolStationSettings,
                  getStationSettings
               }
               }>
               {props.children}
           </StationContext.Provider>
        );
    
}

export default StationContext;